<!--  -->
<template>
  <Card :padding="0" class="member-wrapper" ref="memberCard">
    <div slot="title" class="member-title">参与人</div>
    <!-- 附加功能 -->
    <div slot="extra" class="extra box">
      <div class="icontext" @click="downloadFile()">
        <span class="iconfont icon-daochu icon"></span>
        <span>导出</span>
      </div>
      <div class="icontext" @click="_refreshPeople({refresh:true})">
        <span class="iconfont icon-zhongzhi icon"></span>
        <span>刷新</span>
      </div>
    </div>
    <!-- 可切换的选项卡 -->
    <div class="tab_warpper">
      <div
        class="tab_item"
        :class="{tab_item_select1 : selectIndex==1}"
        @click="switchTab(1)"
      >签到({{sign.total}}人)</div>
      <div
        class="tab_item"
        :class="{tab_item_select0 : selectIndex==0}"
        @click="switchTab(0)"
      >报名({{apply.total}}人)</div>
    </div>
    <!-- 签到人员列表 -->
    <activity-people-list
      v-show="selectIndex==1"
      :style="{height:bodyHeight}"
      :arr="sign.list"
      :canAdd="true"
      :loadFinish="sign.loadFinish"
      :loadComplete="sign.loadComplete"
      @scrollPeople="scrollPeople"
      @onDelete="onDelete"
      @onAdd="onShowAdd"
    ></activity-people-list>
    <!-- 报名人员列表 -->
    <activity-people-list
      v-show="selectIndex==0"
      :style="{height:bodyHeight}"
      :arr="apply.list"
      :loadFinish="apply.loadFinish"
      :loadComplete="apply.loadComplete"
      @onDelete="onDelete"
      @scrollPeople="scrollPeople"
    ></activity-people-list>
    <!-- modal 区域 -->
    <Modal v-model="showAdd" title="补签" width="660px" @on-ok="addConfirm" @on-cancel="addCancel">
      <!-- 补签内容区域 -->
      <div class="add-wrapper">
        <!-- 补签搜索 展示 -->
        <div class="add-search">
          <!-- 搜索输入框 -->
          <Input
            class="add-input"
            placeholder="直接点击搜索可显示已经报名人员"
            size="large"
            type="text"
            search
            enter-button="搜索"
            v-model="searchValue"
            @on-search="onAddSearch"
          />
          <!-- 全选按钮 -->
          <div
            class="select-all"
            @click="selectAll"
            v-if="searchResList.length"
          >{{searchSelectAll?'取消全选':'全选'}}</div>
          <!-- 没有搜索结果提示 -->
          <div class="nolist" v-if="noSearchResult">未搜索到该用户，请确认系统存在该用户或者在社区管理-居民中新增用户。</div>
          <!-- 搜索结果列表 -->
          <div class="search-list" v-if="searchResList.length">
            <!-- 结果类目 -->
            <div
              class="search-item"
              :class="{select:item.select}"
              @click="onSelect(index)"
              v-for="(item,index) in searchResList"
              :key="item.id"
            >
              <!-- 已报名 -->
              <div class="search-item-apply" v-if="item.isApply">
                <div class="apply-state">已报名</div>
              </div>
              <!-- 头像 -->
              <img
                class="search-avatar"
                v-lazy="item.headPicUrl || require('@/assets/images/default.png')"
              >
              <!-- 名字 -->
              <span class="search-name">{{item.realName}}</span>
              <span class="userName">{{item.userName}}</span>
            </div>
          </div>
        </div>
        <!-- 勾选人员列表 -->
        <div class="select-list">
          <div
            class="select-item"
            v-for="(selectItem,selectIndex) in searchSelectList"
            :key="selectItem.id"
          >
            {{selectItem.userName}}
            <span
              class="select-del"
              title="移除"
              @click="removeSelect(selectItem.id)"
            ></span>
          </div>
        </div>
      </div>
    </Modal>
  </Card>
</template>

<script>
var that;
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import miniTab from "./miniTab";
import activityPeopleList from "./activityPeopleList";
export default {
  //import引入的组件需要注入到对象中才能使用
  props: {
    id: null,
    appTypeList:null
  },
  components: {
    miniTab,
    activityPeopleList
  },
  data() {
    //这里存放数据
    return {
      bodyHeight: "",
      showAdd: false, // 是否显示添加签到人
      searchValue: "", // 搜索的值
      searchResList: [], // 搜索结果集
      searchSelectAll: false, // 搜索结果集全选
      noSearchResult: false, // 没有搜索结果
      searchSelectMap: new Map(), //  选中结果的map解构
      mapDriver: 1, // 由于 vue 不支持map 只能用这玩意驱动 了
      selectIndex: -1, // tabbar 选择的索引
      curObj: null, // 当前对象指针
      apply: {
        pageNum: 1, // 分页
        pageSize: 30, // 分页数量
        total: 0, // 总数
        recordType: "apply", // 对象类型
        loadComplete: false, // 是否加载全部数据
        loadFinish: false, // 加载完成
        loadOnce: false, // 只加载一次
        list: [] // 对象数据列表
      },
      sign: {
        pageNum: 1,
        pageSize: 30,
        total: 0,
        recordType: "sign",
        loadComplete: false,
        loadFinish: false, // 加载完成
        loadOnce: false, // 只加载一次
        list: []
      }
    };
  },
  //监听属性 类似于data概念
  computed: {
    // 获取选中的结果集
    searchSelectList() {
      return (
        this.mapDriver &&
        [...this.searchSelectMap.values()].filter(item => item.select)
      );
    },
    // 搜索后选中结果的id集
    searchSelectId() {
      return this.searchSelectList.map(item => item.id);
    }
  },
  //监控data中的数据变化
  watch: {
    selectIndex() {
      // 修改指向
      if (this.selectIndex == 0) {
        this.curObj = this.apply;
      }
      if (this.selectIndex == 1) {
        this.curObj = this.sign;
      }
      // 每个对象只会请求一次 剩余的手动刷新
      !this.curObj.loadOnce && this.getPeople({ refresh: true });
    },
    appTypeList (newValue,oldValue) {
      this.initApplyTotal();
      this._refreshPeople = this._.debounce(this.getPeople, 500); // 500 毫秒限频 用户刷新
      this.selectIndex = 1; //初始化选项 监听数据 驱动刷新
    }
  },
  //方法集合
  methods: {
    // 滚动加载
    scrollPeople() {
      // 加载完成直接返回
      if (that.curObj.loadComplete) {
        return;
      }
      ++that.curObj.pageNum;
      that.getPeople();
    },
    // 删除当前对象的数据列表的索引指向人
    onDelete(index) {
      let url = this.urlobj.delApplyOrSign(this.curObj.list[index].id);
      this.$delete(url).then(res => {
        this.$Message.success("删除成功！");
        this._refreshPeople({ refresh: true }); // 刷新列表
      });
    },
    // 显示添加签到人
    onShowAdd() {
      this.showAdd = true;
      // 自动调一次搜索
      this.onAddSearch();
    },
    // 签到人搜索
    onAddSearch() {
      let url = this.urlobj.people4unsign;
      let data = {
        id: this.id,
        pageNum: 0,
        pageSize: 0,
        userName: this.searchValue,
        appTypeList:this.appTypeList
      };

      this.$post(url, data).then(res => {
        // 根据id把人员去重
        this.searchResList = this.$util.uniqueByKey(
          res.rows.map(item => {
            return {
              headPicUrl: item.headPicUrl, // 头像
              id: item.id, // id
              isApply: item.isApply, // 是否已报名
              unionId: item.unionId, // unionId
              userName: item.userName, // 姓名
              realName: item.realName?item.realName:'暂无姓名',
              select: this.searchSelectId.includes(item.id) // 是否被选中 id是否出现在被选中的列表里
            };
          }),
          "id"
        );
        this._checkSelectAll(); // 判断是否全选
        // 没有搜索结果
        if (!this.searchResList.length) this.noSearchResult = true;
        if (this.searchResList.length) this.noSearchResult = false;
      });
    },
    /* 选中 搜索结果列表的人 */
    onSelect(index) {
      let _cur = this.searchResList[index];
      _cur.select = !_cur.select;
      this._checkSelectAll(); // 判断是否全选
      // 通过id映射选中列表
      this.searchSelectMap.set(_cur.id, _cur);
      this.mapDriver += 1; // 驱动吧
    },
    /* 判断是否全选 */
    _checkSelectAll() {
      for (const item of this.searchResList) {
        if (item.select == false) {
          this.searchSelectAll = false;
          return;
        }
      }
      this.searchSelectAll = true;
    },
    /* 全选搜索列表人 */
    selectAll() {
      // 如果是非全选状态
      if (!this.searchSelectAll) {
        for (const item of this.searchResList) {
          item.select = true;
          this.searchSelectMap.set(item.id, item);
        }
        this.searchSelectAll = true;
        this.mapDriver += 1;
        return;
      }
      // 如果是全选状态
      if (this.searchSelectAll) {
        for (const item of this.searchResList) {
          item.select = false;
          this.searchSelectMap.set(item.id, item);
        }
        this.searchSelectAll = false;
        this.mapDriver += 1;
        return;
      }
    },
    // 从选择列表里移除某个人
    removeSelect(id) {
      // 移除某个人
      // this.searchSelectMap.delete(this.searchSelectList[index].id);
      this.searchSelectMap.delete(id)
      this.mapDriver += 1;
      // 更新 搜索列表
      this.searchResList.forEach(item => {
        if (!this.searchSelectId.includes(item.id)) item.select = false;
      });
      this._checkSelectAll();
    },
    // 确认添加签到人
    addConfirm() {
      if (!this.searchSelectList.length) {
        this.$Message.info("未选择补签人员！");
        return;
      }
      let url = this.urlobj.activitySign(this.id);
      var signType = ''
      this.appTypeList.forEach(item => {
        if (item == 'mst') signType='resident'
        else if (item == 'xfej') signType='party'
      })
      let data = {
        unionIds: this.searchSelectList.map(item => item.unionId).join(","),
        signType,
      };

      this.$store.commit("updateSpinShow", true);
      this.$post(url, data)
        .then(res => {
          this.$store.commit("updateSpinShow", false);

          if (res.isSucceed) {
            this.$Message.success("添加补签人成功！");
            this.searchSelectMap.clear(); // 清空所有数据
            this.mapDriver += 1; //驱动更新
            // 清空搜索列表数据
            this.searchResList = [];
            // 刷新签到列表
            this._refreshPeople({ refresh: true });
          }
        })
        .catch(e => console.log(e));
    },
    // 取消添加签到人
    addCancel() {
      this.searchSelectMap.clear(); // 清空所有数据
      this.mapDriver += 1; //驱动更新
      // 清空搜索列表数据
      this.searchResList = [];
    },
    /* 点击选项卡 进行切换 */
    switchTab(index) {
      this.selectIndex = index;
    },
    // 获取当前对象的人员列表
    getPeople({ refresh = false } = {}) {
      that.curObj.loadFinish = false; // 未取到数据
      if (refresh) {
        that.curObj.pageNum = 1; // 刷新初始化分页
      }
      let data = {
        id: that.id,
        pageNum: that.curObj.pageNum,
        pageSize: that.curObj.pageSize,
        recordType: that.curObj.recordType,
        appTypeList: that.appTypeList
      };
      that.$post(that.urlobj.getActivityPeople, data).then(res => {
        that.curObj.loadFinish = true; // 取到数据
        // 判断是否加载全部
        if (res.rows.length < that.curObj.pageSize) {
          that.curObj.loadComplete = true;
        }
        // 加载一次标识
        if (!that.curObj.loadOnce) that.curObj.loadOnce = true;
        // 格式化返回数据
        let _resList = res.rows.map(item => {
          return {
            id: item.id, // 人员id
            headPicUrl: item.headPicUrl,
            userName: item.userName || "游客",
            //canDelete: that.curObj.recordType === "sign"
            canDelete:true
          };
        });
        // 更新总数
        that.curObj.total = res.total;
        console.log(res.total)
        // 刷新赋值
        if (refresh) {
          that.curObj.list = _resList;
        }
        // 不刷新 追加
        if (!refresh) {
          that.curObj.list.push(..._resList);
        }
        // 存起来 用于 更新活动详情 报名人数信息
        that.curObj === that.apply &&
          this.$store.commit("updateEnroll", res.total);
      });
    },
    // 获取 报名人数目
    initApplyTotal() {
      that
        .$post(that.urlobj.getActivityPeople, {
          id: that.id,
          pageNum: 1,
          pageSize: 1,
          recordType: "apply",
          appTypeList:this.appTypeList
        })
        .then(res => {
          that.apply.total = res.total; // 初始化签到人数
          // console.log(res.total)
        });
    },
    // 导出 excel
    downloadFile() {
      window.open(this.urlobj.downloadFile(this.id));
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    that = this;
    // this._refreshPeople = this._.debounce(this.getPeople, 500); // 500 毫秒限频 用户刷新

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.bodyHeight =
      parseInt(this.$refs.memberCard.$el.offsetHeight * 0.8) + "px";

  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
.member-wrapper {
  width: 300px;
}
.member-title {
  height: 28px;
  line-height: 28px;
}
.extra {
  height: 28px;
  line-height: 28px;
  cursor: pointer;
}
.tab_warpper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}
.tab_item {
  margin: 0 20px;
  cursor: pointer;
  color: #999;
  font-size: 14px;
  transition: color 0.3s ease-in-out;
}
.tab_item:after {
  content: "";
  display: block;
  width: 30px;
  border-bottom: 2px solid #fff;
  margin: 0 auto;
}
.tab_item_select0 {
  color: #46bb53;
}
.tab_item_select1 {
  color: #fe7b43;
}
.tab_item_select0:after {
  border-bottom: 2px solid #46bb53;
}
.tab_item_select1:after {
  border-bottom: 2px solid #fe7b43;
}

.icon {
  margin-right: 2px;
}

.icontext span {
  font-size: 14px;
  color: #67799d;
}
.icontext:last-child {
  margin-left: 10px;
}
.icon span {
  font-size: 16px;
}
/* 对话框 （新增签到人） */
@mainColor: #ff7b44;
.add-wrapper {
  height: 366px;
  display: flex;
  align-items: center;
}
.add-search {
  width: 400px;
  height: 100%;
  border-right: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  padding-right: 10px;
}
.add-input {
  margin-bottom: 10px;
}
/* 搜索结果列表 */
.noIEBar {
  // ie 10 11 12
  -ms-scroll-chaining: chained;
  -ms-overflow-style: none;
  -ms-content-zooming: zoom;
  -ms-scroll-rails: none;
  -ms-content-zoom-limit-min: 100%;
  -ms-content-zoom-limit-max: 500%;
  -ms-scroll-snap-type: proximity;
  -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
  -ms-overflow-style: none;
}
.select-all {
  align-self: flex-end;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1;
  color: #fff;
  border-radius: 4px;
  background-color: #ff5b33;
  margin: 10px 0;
  cursor: pointer;
  user-select: none;
  &:hover {
    background-color: #ff7c5c;
  }
}
.nolist {
  flex: 1;
  font-size: 12px;
  color: #d22b2b;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-list {
  flex: 1;
  padding-top: 10px;
  padding-right: 10px;
  overflow: hidden;
  overflow-y: scroll;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 15px;
  align-content: start;
  // chrome
  &::-webkit-scrollbar {
    display: none;
  }
  .noIEBar;
}
.search-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 150px;
  border: 1px solid #eee;
  border-radius: 8px;
  &:hover {
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
  }
}
/* 已报名 */
.search-item-apply {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-top: 22px solid #47ba53;
  border-right: 22px solid transparent;
  border-left: 22px solid #47ba53;
  border-bottom: 22px solid transparent;
  border-top-left-radius: 8px;
}
.apply-state {
  position: absolute;
  top: -13px;
  left: -24px;
  font-size: 12px;
  color: #fff;
  line-height: 1.1;
  white-space: nowrap;
  transform: rotate(-45deg) scale(0.8);
}
.select {
  border-color: @mainColor;
}
.select:after {
  content: "";
  position: absolute;
  right: -10px;
  top: -10px;
  z-index: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: @mainColor;
}
.select:before {
  content: "";
  position: absolute;
  right: -3px;
  top: -6px;
  z-index: 1;
  width: 6px;
  height: 10px;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  transform: rotateZ(45deg);
}
.search-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-top: 30px;
  margin-bottom: 20px;
}
.search-name {
  font-size: 14px;
  color: #444;
}
.userName{
  text-align: center;
  color: #999;
}
/* 选中人员列表 */
.select-list {
  max-height: 100%;
  flex: 1;
  align-self: flex-start;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: flex-start;
  overflow: hidden;
  overflow-y: scroll;

  padding-left: 20px;
  &::-webkit-scrollbar {
    display: none;
  }
  .noIEBar;
}
.select-item {
  display: flex;
  align-items: center;

  white-space: nowrap;
  margin-right: 5px;
  margin-bottom: 10px;
  padding: 6px 10px;

  line-height: 1.2;
  font-size: 14px;
  color: #999;
  border: 1px dashed #999;
  border-radius: 4px;
  &:hover {
    color: @mainColor;
    border-color: @mainColor;
    .select-del {
      background-color: @mainColor;
    }
  }
}
/* 删除按钮伪类 */
.select-del-icon(@rotate:0) {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 7px;
  height: 1px;
  background-color: #fff;
  transform: translate(-50%, -50%) rotateZ(@rotate);
}
/* 删除按钮 */
.select-del {
  position: relative;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-left: 5px;
  color: #fff;
  background-color: #999;
  cursor: pointer;
  &::before {
    .select-del-icon(45deg);
  }
  &::after {
    .select-del-icon(-45deg);
  }
}
</style>
